import { useState, useEffect } from 'react';
import api from '../../utils/api';

/**
 * Fetches /immigration/workflow-definitions/:workflowType (data envelope = payload object).
 * @param {'gc' | 'h1_lottery' | 'everify_new'} workflowType
 */
export function useImmigrationWorkflowDefinition(workflowType) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancel = false;
    setLoading(true);
    setError('');
    (async () => {
      try {
        const res = await api.get(`/immigration/workflow-definitions/${workflowType}`);
        const payload = res.data?.data;
        if (!cancel) setData(payload || null);
      } catch (e) {
        if (!cancel) {
          setData(null);
          setError(e.response?.data?.message || 'Load failed');
        }
      } finally {
        if (!cancel) setLoading(false);
      }
    })();
    return () => {
      cancel = true;
    };
  }, [workflowType]);

  return { data, loading, error };
}
